export const CAMPAIGN_END = Date.parse('2026-11-30T23:59:59-05:00');
export const CAMPAIGN_KEY = 'tree.thanksgiving.2026';

export function campaignEligible(customerKey, expires, now = Date.now()) {
  const end = Date.parse(expires);
  return Boolean(customerKey) && Number.isFinite(end) && now <= Math.min(end, CAMPAIGN_END);
}

export function campaignSeen(storage, customerKey) {
  try {
    const entry = JSON.parse(storage.getItem(CAMPAIGN_KEY) || 'null');
    return entry?.customerKey === customerKey && entry?.shown === true;
  } catch {
    return true;
  }
}

export function setupThanksgiving(doc = document, win = window) {
  const state = doc.querySelector('[data-tree-thanksgiving-state]');
  if (!state || state.dataset.designMode === 'true') return;
  let storage;
  try { storage = win.sessionStorage; } catch { return; }
  const customerKey = state.dataset.customerKey;
  if (!customerKey) {
    try { storage.removeItem(CAMPAIGN_KEY); } catch { /* Storage can be disabled. */ }
    return;
  }
  const dialog = doc.getElementById('TreeThanksgivingOffer');
  if (!dialog || !campaignEligible(customerKey, state.dataset.expires) || campaignSeen(storage, customerKey)) return;
  const previousFocus = doc.activeElement;
  const close = () => dialog.close();
  const onClose = () => {
    doc.body.classList.remove('tc-thanks-open');
    if (previousFocus?.isConnected && typeof previousFocus.focus === 'function') previousFocus.focus({ preventScroll: true });
  };
  dialog.querySelector('[data-thanks-close]').addEventListener('click', close);
  dialog.addEventListener('close', onClose);
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const rect = dialog.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  const copyButton = dialog.querySelector('[data-thanks-copy]');
  copyButton.addEventListener('click', async () => {
    const label = dialog.querySelector('[data-thanks-copy-label]');
    try {
      await win.navigator.clipboard.writeText('TREE10');
      label.textContent = copyButton.dataset.copiedLabel;
    } catch {
      label.textContent = copyButton.dataset.fallbackLabel;
    }
    dialog.querySelector('[data-thanks-status]').textContent = label.textContent;
  });
  dialog.querySelector('[data-thanks-shop]').addEventListener('click', () => {
    try { win.navigator.clipboard?.writeText('TREE10').catch(() => {}); } catch { /* The discount link works without the clipboard. */ }
    close();
  });
  function maybeShow() {
    if (!campaignEligible(customerKey, state.dataset.expires) || campaignSeen(storage, customerKey)) {
      doc.removeEventListener('close', afterOtherDialog, true);
      return;
    }
    if (doc.querySelector('dialog[open]')) return;
    try {
      dialog.showModal();
      doc.body.classList.add('tc-thanks-open');
      storage.setItem(CAMPAIGN_KEY, JSON.stringify({ customerKey, shown: true }));
      dialog.querySelector('#TreeThanksgivingTitle').focus({ preventScroll: true });
    } catch {
      if (dialog.open) dialog.close();
    }
    doc.removeEventListener('close', afterOtherDialog, true);
  }
  function afterOtherDialog(event) {
    if (event.target !== dialog) win.queueMicrotask(maybeShow);
  }
  doc.addEventListener('close', afterOtherDialog, true);
  win.setTimeout(maybeShow, 700);
}

if (typeof document !== 'undefined') setupThanksgiving();
